<page-toolbar [title]="'myOrganization.mainTitle' | translate"></page-toolbar>

<page-content>
  <form [formGroup]="form">
    <mat-card appearance="outlined" class="form-container">
      <mat-card-title>{{'myOrganization.customer' | translate}}</mat-card-title>
      <div formGroupName="name">
        <mat-form-field>
          <mat-label>{{'myOrganization.title' | translate}}</mat-label>
          <input formControlName="title" matInput>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{'myOrganization.firstName' | translate}}</mat-label>
          <input formControlName="firstName" matInput>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{'myOrganization.lastName' | translate}}</mat-label>
          <input formControlName="lastName" matInput>
        </mat-form-field>
      </div>
    </mat-card>

    <div class="spacer"></div>

    <mat-card appearance="outlined" class="form-container">
      <mat-card-title>{{'myOrganization.contact' | translate}}</mat-card-title>
      <div formGroupName="contact">
        <mat-form-field>
          <mat-label>{{'myOrganization.mail' | translate}}</mat-label>
          <input formControlName="mail" matInput>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{'myOrganization.tel' | translate}}</mat-label>
          <input formControlName="tel" matInput>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{'myOrganization.url' | translate}}</mat-label>
          <input formControlName="url" matInput>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{'myOrganization.fax' | translate}}</mat-label>
          <input formControlName="fax" matInput>
        </mat-form-field>
      </div>
    </mat-card>

    <div class="spacer"></div>

    <mat-card appearance="outlined" class="form-container">
      <mat-card-title>{{'myOrganization.address' | translate}}</mat-card-title>
      <div formGroupName="address">
        <mat-form-field>
          <mat-label>{{'myOrganization.street' | translate}}</mat-label>
          <input formControlName="street" matInput>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{'myOrganization.streetAdditional' | translate}}</mat-label>
          <input formControlName="streetAdditional" matInput>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{'myOrganization.zip' | translate}}</mat-label>
          <input formControlName="zip" matInput>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{'myOrganization.city' | translate}}</mat-label>
          <input formControlName="city" matInput>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{'myOrganization.countryCode' | translate}}</mat-label>
          <input formControlName="countryCode" matInput>
        </mat-form-field>
      </div>
    </mat-card>

    <div class="spacer"></div>

    <mat-card appearance="outlined" class="form-container">
      <mat-form-field>
        <mat-label>{{'myOrganization.comment' | translate}}</mat-label>
        <input formControlName="comment" matInput>
      </mat-form-field>
    </mat-card>
  </form>




  <div class="spacer"></div>

</page-content>
